<template>
  <div>
    <info-list
      :form-model="formModel"
      :headers="headers"
    ></info-list>
  </div>
</template>

<script>
import InfoList from '@/modules/bankruptcy/components/bankruptcy-file/info-list.vue';
import { toHijriDate, toGeorgianDateString } from '@/helpers/utils';

export default {
  components: { InfoList },
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      toHijriDate,
      toGeorgianDateString,
      headers: [
        {
          key: 'identityTypeName',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.identityType,
        },
        {
          key: 'identityNumber',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.identityNumber,
        },
        {
          key: 'dateOfBirth',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.dateOfBirth,
          formatter: toHijriDate,
        },
        {
          key: 'fullName',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.name,
        },
        {
          key: 'commercialRegistrationNumber',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.commercialRegistrationNumber,
        },
        {
          key: 'unifiedNumber',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.unifiedNumber,
        },
        {
          key: 'managerFullName',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.managerFullName,
        },
        {
          key: 'mobile',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.mobile,
        },
        {
          key: 'email',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.email,
        },
        {
          key: 'debtValue',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.debtValue,
        },
        {
          key: 'dueDate',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.dueDateHijri,
          formatter: toHijriDate,
        },
        {
          key: 'dueDate',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.dueDateGregorian,
          formatter: toGeorgianDateString,
        },
        {
          key: 'debtOrigin',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.debtOrigin,
        },
        {
          key: 'countryName',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.countryId,
        },
        {
          key: 'cityName',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.cityId,
        },
        {
          key: 'paymentStatus',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.paymentStatusId,
        },
        {
          key: 'receivedPayment',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.receivedPayment,
        },
        {
          key: 'remainingPayment',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.remainingPayment,
        },
        {
          key: 'creditorClassificationsName',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.creditorClassificationId,
        },
        {
          key: 'otherCreditorClassification',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.otherCreditorClassification,
        },
        {
          key: 'isGuaranteed',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.isGuaranteed,
          formatter: (val) => { return val ? this.local.common.yes : this.local.common.no; },
        },
        {
          key: 'guaranteeType',
          text: this.local.bankruptcy.requestDetails.bankruptDebts.guaranteeType,
        },
        {
          key: 'managerFullName',
          text: this.local.bankruptcy.requestDetails.partners.managerName,
        },
        {
          key: 'managerIdentityNumber',
          text: this.local.personInformation.socialId,
        },
        {
          key: 'passportDate',
          text: this.local.personInformation.passportDate,
        },
        {
          key: 'passportSource',
          text: this.local.personInformation.passportSource,
        },
      ],
    };
  },
  computed: {},
  mounted() {

  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
